export const getRangeArray = (start, end) => {
    const arr = [];
    let i = start;
    while (i < end) {
        arr.push(i);
        i++;
    }
    return arr;
}